import { Box } from '@rover/kibble/core';
import IconBlock from '@rover/kibble/patterns/IconBlock/IconBlock';
import type { SvgIcon } from '@rover/types/src/SvgIcon';

const Skill = ({ icon, title }: { icon: SvgIcon; title: string }): JSX.Element => {
  return (
    <Box py="2x">
      <IconBlock iconSize="24px" size="200" fontWeight="regular" icon={icon} title={title} />
    </Box>
  );
};

export default Skill;
